import { setUnreadMessagesCounter } from "store/slices/reportsSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "./reduxToolkit";

export const useMessages = () => {
  const dispatch = useDispatch();

  return {
    getUnreadMessagesCount: useAppSelector((state) => {
      return state.reportsSliceReducer.newMessagesCounter;
    }),
    setUnreadMessagesCount: (count: number) =>
      dispatch(setUnreadMessagesCounter(count)),
  };
};
